import React, { SVGProps } from 'react';

export const QuestionIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 25,
  height = 25,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 25 25"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M12.5 25C19.4037 25 25 19.4037 25 12.5C25 5.59625 19.4037 0 12.5 0C5.59625 0 0 5.59625 0 12.5C0 19.4037 5.59625 25 12.5 25ZM11.1425 14.095C11.0375 14.795 11.6325 15.3725 12.34 15.3725H12.9275C13.0944 15.3725 13.2551 15.3089 13.3767 15.1947C13.4984 15.0804 13.572 14.9241 13.5825 14.7575C13.6538 14.1 13.9362 13.525 14.4275 13.0338L15.215 12.2587C15.83 11.64 16.26 11.0787 16.5063 10.575C16.7525 10.0638 16.875 9.5225 16.875 8.95125C16.875 7.695 16.4963 6.72375 15.7387 6.03875C14.9812 5.34625 13.9163 5 12.5437 5C11.1838 5 10.11 5.3625 9.31875 6.08875C8.85039 6.52318 8.50794 7.07594 8.3275 7.68875C8.0975 8.44375 8.7775 9.1025 9.565 9.1025C10.2325 9.1025 10.7313 8.55875 11.195 8.0525C11.26 7.98125 11.3237 7.91 11.3875 7.8425C11.68 7.53375 12.065 7.38 12.5437 7.38C13.5538 7.38 14.0588 7.9475 14.0588 9.0825C14.0588 9.45875 13.9613 9.81875 13.7675 10.1612C13.5737 10.4975 13.1813 10.9375 12.5925 11.4813C12.01 12.0188 11.6087 12.5675 11.3875 13.125C11.2787 13.4012 11.1975 13.725 11.1425 14.095ZM11.2137 17.3587C10.9225 17.6475 10.7763 18.0175 10.7763 18.4675C10.7763 18.9113 10.9188 19.2775 11.2038 19.5675C11.495 19.855 11.8775 20 12.35 20C12.8225 20 13.2 19.855 13.4862 19.5662C13.7775 19.2775 13.9237 18.9113 13.9237 18.4675C13.9237 18.0175 13.7738 17.6475 13.4762 17.3587C13.185 17.0625 12.8088 16.915 12.35 16.915C11.89 16.915 11.5125 17.0625 11.2137 17.3587Z"
        fill="url(#paint0_linear_442_646)"
        fillRule="evenodd"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_442_646"
          x1="0"
          x2="25"
          y1="12.5"
          y2="12.5"
        >
          <stop stopColor="#285386" />
          <stop offset="1" stopColor="#C53737" />
        </linearGradient>
      </defs>
    </svg>
  );
};
